import _import from './_import.js';

export default [
    // // s1
    // {
    //     path: 'worldphone/s1',
    //     component: _import('worldphone/s1')
    // },
    // // p3
    // {
    //     path: 'worldphone/p3',
    //     component: _import('worldphone/p3')
    // },
    // // why_glocalme_world_phone
    // {
    //     path: 'worldphone/why_glocalme_world_phone',
    //     component: _import('worldphone/why_glocalme_world_phone')
    // },
    // // s20i
    // {
    //     path: 'worldphone/s20i',
    //     component: _import('worldphone/s20i')
    // },

    // worldphone 动态路由
    {
        path: 'worldphone/:type',
        component: _import('worldphone/common_phone')
    }
];



// WEBPACK FOOTER //
// ./src/router/worldphone.js